import { setEvents } from "../events";

export function setProp65Tracking() {
  setEvents({
    events: ["event276"],
    trackingName: "postPageLoad",
  });
}
